import mapData from "@highcharts/map-collection/countries/us/us-all.geo.json";

export const MAP_CHART: Highcharts.Options = {
  chart: {
    map: mapData,
  },
  title: {
    text: "",
    align: "left",
  },
  subtitle: {
    text: "",
  },
  credits: {
    enabled: false,
  },
  mapNavigation: {
    enabled: false,
    buttonOptions: {
      verticalAlign: "bottom",
    },
  },
  colorAxis: {
    min: 0,
    max: 30,
    minColor: "#EEEEFF",
    maxColor: "#000022",
    stops: [
      [0, "#EFEFFF"],
      [0.67, "#4444FF"],
      [1, "#000022"],
    ],
  },
  accessibility: {
    enabled: false,
  },
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
};
